/* eslint-disable import/prefer-default-export */
import * as R from 'ramda'

export const hasOneElement = R.compose(R.equals(1), R.length)
